import React, { useState, useEffect, memo } from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import PageSpinner from '@Components/Loader';
import { MainLayout } from '@Components/Layout';
import Constant from '@Constant';
const PatientPage = React.lazy(() => import('@Pages/Patient/'));
const ReferPage = React.lazy(() => import('@Pages/Refer/'));
const ReferDetailPage = React.lazy(() => import('@Pages/Refer_Detail/'));
const Blog = React.lazy(() => import('@Pages/Blogs/'));
const BlogDetail = React.lazy(() => import('@Pages/Blogs/Blog_Detail'));


const App = memo((props) => {
    let regex = new RegExp("[\\?&]invite_code=([^&#]*)");
    let results = regex.exec(window.location.href);
    Constant.invitationCode = results === null
        ? ""
        : decodeURIComponent(results[1]);
    return (
        <React.Suspense fallback={<PageSpinner />}>
            <BrowserRouter>
                <Switch>
                    <Route exact path="/">
                        <Redirect to="/patient" />
                    </Route>
                    <MainLayout path="/patient" component={PatientPage} pageHeaderTitle={'mainPage'} {...props} />
                    <MainLayout path="/referpage" component={ReferPage} pageHeaderTitle={'referPage'} {...props} />
                    <MainLayout path="/referdetail" component={ReferDetailPage} pageHeaderTitle={'referDetailPage'} {...props} />
                    <MainLayout path="/blog" component={Blog} pageHeaderTitle={'blogPage'} {...props} />
                    <MainLayout path="/blogdetail/:blog"
                        component={BlogDetail}
                        pageHeaderTitle={'blogDetailPage'}
                        {...props}
                    />
                    <Redirect to="/patient" />
                </Switch>
            </BrowserRouter>
        </React.Suspense>
    );
});

export default App;
